<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="行程问题记录"
    width="1300px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-button type="primary" size="small" @click="addRouteProblem(routeId)">新增问题</el-button>
    <el-table :data="routeProblemList" style="margin-top: 10px" v-loading="routeProblemLoading">
      <el-table-column label="问题" prop="problem">
        <template slot-scope="scope">
          <div v-if="editingIndex === scope.$index">
            <el-input
              v-model="editingForm.problem"
              type="textarea"
              :rows="2"
              placeholder="请输入问题"
            />
          </div>
          <div v-else>{{ scope.row.problem }}</div>
        </template>
      </el-table-column>

      <el-table-column label="建议" prop="suggestion" width="200">
        <template slot-scope="scope">
          <div v-if="editingIndex === scope.$index">
            <el-input
              v-model="editingForm.suggestion"
              type="textarea"
              :rows="2"
              placeholder="请输入建议"
            />
          </div>
          <div v-else>{{ scope.row.suggestion }}</div>
        </template>
      </el-table-column>
      <el-table-column label="结论" prop="result" width="200">
        <template slot-scope="scope">
          <div v-if="editingIndex === scope.$index">
            <el-input
              v-model="editingForm.result"
              type="textarea"
              :rows="2"
              placeholder="请输入建议"
            />
          </div>
          <div v-else>{{ scope.row.result }}</div>
        </template>
      </el-table-column>

      <el-table-column label="关联方" prop="causer" width="120">
        <template slot-scope="scope">
          <div v-if="editingIndex === scope.$index">
            <el-select v-model="editingForm.causer" placeholder="请选择关联方" style="width: 100px">
              <el-option
                v-for="item in routeProblemCauserOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div v-else>
            {{
              (routeProblemCauserOptions.find((opt) => opt.value === scope.row.causer) || {})
                .label || scope.row.causer
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否采纳" prop="accept" width="100">
        <template slot-scope="scope">
          <div v-if="editingIndex === scope.$index">
            <el-select v-model="editingForm.accept" placeholder="请选择是否采纳">
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </div>
          <div v-else>{{ scope.row.accept ? "是" : "否" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="上报人" prop="uploader" width="100">
        <template slot-scope="scope">
          <div v-if="editingIndex === -1">{{ scope.row.uploader }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="150">
        <template slot-scope="scope">
          <div v-if="editingIndex === -1">{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <div v-if="editingIndex === scope.$index">
            <el-button type="primary" size="small" @click="saveRouteProblem">保存</el-button>
            <el-button size="small" @click="cancelEditRouteProblem">取消</el-button>
          </div>
          <div v-else>
            <el-button type="text" size="small" @click="editRouteProblem(scope.row, scope.$index)"
              >编辑</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button :size="size" @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRouteProblemList, saveOrUpdateRouteProblem } from "@/api";
import { BaseDataService } from "@/service";
export default {
  name: "RouteProblemDialog",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    routeId: {
      type: [String, Number],
      required: true
    },
    size: {
      type: String,
      default: "small"
    }
  },
  data() {
    return {
      visibleProxy: this.visible,
      routeProblemList: [],
      routeProblemLoading: false,
      editingIndex: -1,
      editingForm: {},
      routeProblemCauserOptions: BaseDataService.routeProblemCauserOptions()
    };
  },
  watch: {
    visible(val) {
      this.visibleProxy = val;
      if (val) {
        this.fetchList();
      }
    },
    visibleProxy(val) {
      this.$emit("update:visible", val);
    },
    routeId(val) {
      if (this.visibleProxy && val) {
        this.fetchList();
      }
    }
  },
  methods: {
    handleClose() {
      this.visibleProxy = false;
    },
    async fetchList() {
      if (!this.routeId) return;
      this.routeProblemLoading = true;
      this.editingIndex = -1;
      try {
        const res = await getRouteProblemList(this.routeId);
        this.routeProblemList = res.data || [];
      } finally {
        this.routeProblemLoading = false;
      }
    },
    editRouteProblem(item, index) {
      this.editingIndex = index;
      this.editingForm = { ...item };
    },
    cancelEditRouteProblem() {
      this.editingIndex = -1;
      this.editingForm = {};
    },
    async saveRouteProblem() {
      this.routeProblemLoading = true;
      try {
        if (!this.editingForm.problem) {
          this.$message.error("请填写问题");
          this.routeProblemLoading = false;
          return;
        }
        if (!this.editingForm.causer) {
          this.$message.error("请选择关联方");
          this.routeProblemLoading = false;
          return;
        }
        await saveOrUpdateRouteProblem(this.editingForm);
        this.$message.success("保存成功");
        // 刷新列表
        await this.fetchList();
        this.editingIndex = -1;
        this.editingForm = {};
      } finally {
        this.routeProblemLoading = false;
      }
    },
    addRouteProblem(routeId) {
      this.routeProblemList.push({
        id: undefined,
        problem: "",
        suggestion: "",
        causer: "",
        routeId
      });
      this.editingIndex = this.routeProblemList.length - 1;
      this.editingForm = {
        problem: "",
        suggestion: "",
        causer: "",
        routeId
      };
    }
  }
};
</script>
